(function () {
  var STORAGE_KEY = 'pinch_recently_viewed';
  var MAX_ITEMS = 8;

  function getViewed() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveViewed(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
    catch (e) {}
  }

  // Normalise entry — old format may be a plain handle string
  function normalise(item) {
    return typeof item === 'string' ? { handle: item, collectionImage: null } : item;
  }

  function trackView() {
    var handle = window.currentProductHandle;
    if (!handle) return;
    var viewed = getViewed().map(normalise).filter(function (item) {
      return item.handle !== handle;
    });
    viewed.unshift({
      handle: handle,
      collectionImage: window.currentCollectionImage || null
    });
    saveViewed(viewed.slice(0, MAX_ITEMS));
  }

  function shopifyImageSrc(src, width) {
    if (!src) return '';
    var sep = src.indexOf('?') !== -1 ? '&' : '?';
    return src + sep + 'width=' + width;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function renderCard(product) {
    var imgSrc = product._collectionImage || shopifyImageSrc(product.featured_image, 400);
    var imgHtml = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" class="featured-image" loading="lazy" width="400">'
      : '';
    return '<a href="' + escapeHtml(product.url) + '">'
      + '<div class="product-card">'
      + '<div class="product-images">' + imgHtml + '</div>'
      + '<div class="product-details">'
      + '<div class="product-title-wrapper">'
      + '<h3 class="product-title h3 snug-text">' + escapeHtml(product.title) + '</h3>'
      + '</div></div></div></a>';
  }

  function loadRecentlyViewed() {
    var container = document.getElementById('cart-recently-viewed');
    var slidesWrapper = document.getElementById('recently-viewed-slides');
    if (!container || !slidesWrapper) return;

    var viewed = getViewed().map(normalise);
    if (viewed.length === 0) return;

    Promise.allSettled(
      viewed.map(function (item) {
        return fetch('/products/' + item.handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) return null;
            return r.json().then(function (product) {
              product._collectionImage = item.collectionImage || null;
              return product;
            });
          });
      })
    ).then(function (results) {
      var products = results
        .filter(function (r) { return r.status === 'fulfilled' && r.value; })
        .map(function (r) { return r.value; });

      if (products.length === 0) return;

      slidesWrapper.innerHTML = products.map(function (p) {
        return '<div class="recommendation__item swiper-slide">' + renderCard(p) + '</div>';
      }).join('');

      container.style.display = '';

      var swiperUrl = container.dataset.swiperUrl;
      getScript(swiperUrl, function () {
        new Swiper('.swiper-container--recently-viewed', {
          loop: false,
          allowTouchMove: true,
          spaceBetween: 24,
          slidesPerView: 2,
          navigation: {
            nextEl: '.swiper-next--recently-viewed',
            prevEl: '.swiper-prev--recently-viewed'
          },
          breakpoints: {
            768: { slidesPerView: 4 }
          }
        });
      });
    });
  }

  trackView();

  function init() {
    if (document.getElementById('cart-recently-viewed')) {
      loadRecentlyViewed();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
